<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding">
          <p fade="click" auto ref="lookagain" speed="normal">
            The next day I looked at the book again, thinking it would make more sense, that the things that feel like dreams might become actual memories. I read what looks like a poem. It's structure feels so natural. but the page is wrong
          </p>
          <br>
<p>
            yesterday this page was blank<br>
          </p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Look Again'
    }
  },
  methods: {
    fade () {
      this.$emit('fade', ['lookagain', 'normal'])
    }
  },
  mounted () {
    setTimeout(() => { this.fade() }, 5000)
  }
}
</script>

<style lang="css" scoped>
</style>
